import React from 'react';
import { toggleBigThumbnails, toggleExpandedReplies } from '../../actions';
import {
  accentColorsDark,
  accentColorsLight,
  blackDarkBgs,
  getNextTheme,
} from '../../modules/ThemeSwitcher';
import { setPreference } from '../../modules/Preferences';

class PreferencesMenu extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { expandedReplies, bigThumbnails, preferences } = this.props;

    const {
      theme = 'auto',
      barsPosition = 'bottom',
      blurNSFW = true,
      centeredLayout = false,
      colorL = 0,
      colorD = 0,
      blackDarkBg = 0,
    } = preferences;

    return (
      <div style={{ margin: '1.5rem 0 0' }}>
        <Group heading="Appearance">
          <Item
            onClick={() => {
              setPreference('theme', getNextTheme());
            }}
            label="Theme"
            value={theme.charAt(0).toUpperCase() + theme.slice(1)}
          />

          <Item
            onClick={() => {
              setPreference('colorL', getNextItem(colorL, accentColorsLight));
            }}
            label="Light Theme Accent"
            value={
              <>
                <div
                  style={{
                    marginLeft: '.25rem',
                    display: 'inline-block',
                    width: colorIndicatorSize,
                    height: colorIndicatorSize,
                    borderRadius: '50%',
                    backgroundColor: 'var(--accent-color-l)',
                  }}
                />{' '}
                {accentColorsLight[colorL]}
              </>
            }
          />

          <Item
            onClick={() => {
              setPreference('colorD', getNextItem(colorD, accentColorsDark));
            }}
            label="Dark Theme Accent"
            value={
              <>
                <div
                  style={{
                    marginLeft: '.25rem',
                    display: 'inline-block',
                    width: colorIndicatorSize,
                    height: colorIndicatorSize,
                    borderRadius: '50%',
                    backgroundColor: 'var(--accent-color-d)',
                  }}
                />{' '}
                {accentColorsDark[colorD]}
              </>
            }
          />
          <Item
            onClick={() => {
              setPreference(
                'blackDarkBg',
                getNextItem(blackDarkBg, blackDarkBgs)
              );
            }}
            label="True Black Dark Theme"
            value={blackDarkBgs[blackDarkBg] === 'y' ? 'On' : 'Off'}
          />
        </Group>

        <Group heading="Layout">
          <Item
            onClick={() => {
              toggleBigThumbnails();
            }}
            label="Post Thumbnails"
            value={bigThumbnails ? 'Big' : 'Small'}
          />

          <Item
            onClick={() => {
              setPreference('centeredLayout', !centeredLayout);
            }}
            label={
              <>
                {'Centered Layout'} <br /> {'(wide screens)'}
              </>
            }
            value={centeredLayout ? 'On' : 'Off'}
          />

          <Item
            onClick={() => {
              let newPosition;
              if (barsPosition === 'top') {
                newPosition = 'bottom';
              } else if (barsPosition === 'bottom') {
                newPosition = 'top';
              }
              setPreference('barsPosition', newPosition);
            }}
            label="Bars Position"
            value={barsPosition === 'top' ? 'Top' : 'Bottom'}
          />
        </Group>

        <Group heading="Behavior">
          <Item
            onClick={() => {
              setPreference('blurNSFW', !blurNSFW);
            }}
            label="NSFW Thumbnails"
            value={blurNSFW ? 'Blurred' : 'Regular'}
          />
          <Item
            onClick={() => {
              toggleExpandedReplies();
            }}
            label="Replies"
            value={expandedReplies ? 'Expanded' : 'Collapsed'}
          />
        </Group>
      </div>
    );
  }
}

export default PreferencesMenu;

const colorIndicatorSize = '.75rem';

function Group({ heading, children }) {
  return (
    <div style={{ marginTop: 0, marginBlockEnd: '2rem' }}>
      <h2
        style={{
          fontSize: '1rem',
          letterSpacing: '.5px',
          marginTop: 0,
          textTransform: 'uppercase',
          color: 'var(--text-color-2)',
        }}
      >
        {heading}
      </h2>
      {children}
    </div>
  );
}

function Item({ onClick, label, value }) {
  return (
    <button
      className="reset-button"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
        marginBottom: '1rem',
        textAlign: 'left',
      }}
      onClick={onClick}
    >
      <div>{label}</div>
      <b
        style={{
          padding: '.25rem .5rem',
          backgroundColor: 'var(--bg-color-1)',
          borderRadius: '4px',
          letterSpacing: '.8px',
          textTransform: 'uppercase',
        }}
      >
        {value}
      </b>
    </button>
  );
}

function getNextItem(currentIndex, list) {
  const totalIndex = list.length - 1;
  if (currentIndex === totalIndex) {
    return 0;
  } else {
    return currentIndex + 1;
  }
}
